import {useContext, useState} from "react";
import {Button, FileInput, Stack, TextInput} from "@mantine/core";
import QRCodeContext from "../../../../../contexts/qr-code/QRCodeContext";
import ImageAttachmentApi from "../../../../../api/image-attachment/ImageAttachmentApi";
import {useNavigate} from "react-router-dom";

/**
 * Image input data
 * @qrCodeKind image
 * @author Kacper Faber
 * @since 0.2.0
 */
function ImageInputData() {
    /**
     * QRCodeContext
     * @author Kacper Faber
     * @since 0.2.0
     */
    const qrCodeContext = useContext(QRCodeContext);

    /**
     * Image to be sent as ImageAttachment.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const [image, setImage] = useState<File | null>(null);

    /**
     * QR code name to be set
     * @author Kacper Faber
     * @since 0.2.0
     */
    const [name, setName] = useState<string>('');

    /**
     * Navigate function from react-router-dom
     * @author Kacper Faber
     * @since 0.2.0
     */
    const nav = useNavigate();

    /**
     * On create button is clicked.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const onCreateClicked = () => {
        if (!image) return;

        ImageAttachmentApi.create({image})
            .then(({id}) => qrCodeContext.create({name, kind: 'image', imageAttachment: id}))
            .then(() => nav('/'));
    }

    return (
        <Stack>
            <TextInput
                onChange={e => setName(e.target.value)}
                placeholder="Nazwa kodu QR"
            />

            <FileInput
                placeholder="Zdjecie"
                onChange={setImage}
            />

            <Button
                onClick={onCreateClicked}
                children="ZAPISZ"
            />
        </Stack>
    );
}

export default ImageInputData;